import React, { useState } from "react";
import Styles from "../../assets/css/components/admin/category/categoryAdd.module.scss";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftSLine } from "react-icons/ri";
import axios from "axios";
import { baseUrl } from "../../utils/constant";
import { useDispatch } from "react-redux";
import { popUpBoxTrigger } from "../../features/message/popUpSlice";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const CategoryAdd = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const userData = JSON.parse(localStorage.getItem("user_data"));
    const dispatch=  useDispatch();

    const [formData,setFormData] = useState({
      artist_id: userData.id,
      name: "",
      status: ""
    });

    const [error, setError] = useState({
      name: false,
      status: false,
    });

    const handleSubmit = async (e) => {

        e.preventDefault();

        const errorData = {
        name: false,
        status: false,
        }

        if(formData.name === "") errorData.name = true;
        if(formData.status === "") errorData.status = true;

        if(formData.name === "" || formData.status === ""){
        dispatch(popUpBoxTrigger({type: "error", heading: "Error", message: "Please fill all the fields."}));
        }

        setError(errorData);
        const formDataSet = new FormData();
        formDataSet.append('name', formData.name);
        formDataSet.append('status', formData.status);
        formDataSet.append('artist_id', formData.artist_id);

        const token = localStorage.getItem("token");

        try{

        const data = await axios({
            method: 'POST',
            url: `${baseUrl}admin/category/create`,
            data: formDataSet,
            headers: {
            'Authorization': 'Bearer ' + token
            }
        });

        const result = data;
        console.log(result);
        if(result.data.status === 200){
            setLoading(false);
            dispatch(popUpBoxTrigger({type: "success", heading: "Success", message: result.data.message}));
            navigate('/category');
        }else{
            console.log("Categoray Add Failed");
            dispatch(popUpBoxTrigger({type: "error", heading: "Error", message: "oops!! something went wrong"}));
            setLoading(false);
        }
        }catch (error){

        console.log(error);
        if(error.response.data.status === 422){
            dispatch(popUpBoxTrigger({type: "error", heading: "Error", message: error.response.data.message}));
            setLoading(false);
            return;
        }

        // if(error !== ""){
        //     dispatch(popUpBoxTrigger({type: "error", heading: "Error", message: "oops!! something went wrong"}));
        //     setLoading(false);
        //     return;
        // }
        }
        };

  return (
    <div className={`${Styles.category}`}>

        <div className={`${Styles.category_heading}`}>
            <h2>Category</h2>
        </div>
  
        <div className={`${Styles.categoryAdd}`}>
          <div className={`${Styles.form_heading}`}>
            <h3>Add New Category</h3>
            <button onClick={() => navigate("/category")}>
              <RiArrowLeftSLine /> Go To Category List
            </button>
          </div>
  
          <div className={`${Styles.add_form}`}>
            <div className={`${Styles.form_grid}`}>
                <div className={`${Styles.form_field}`}>
                  <label>Category Name</label>
                  <input type="text" placeholder="Enter Category Name" name="name" onChange={(e) => setFormData({...formData, name:e.target.value})} />
                </div>
                <div className={`${Styles.form_field}`}>
                  <label>Status</label>
                  <select name="status" onChange={(e) => setFormData({...formData, status:parseInt(e.target.value)})} >
                    <option value="">***** Select Status *****</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
            </div>
  
            <div className={`${Styles.buttons}`}>
              <button className={`${Styles.action}`} onClick={handleSubmit} disabled={loading}>{loading ? <AiOutlineLoading3Quarters /> : "Create"}</button>
              <button className={`${Styles.cancel}`} onClick={() => navigate("/category")}>Cancel</button>
            </div>
          </div>

        </div>
    </div>
  )
}

export default CategoryAdd
